import type { DatePickerProps as ReactDatePickerProps } from "react-datepicker"
import ReactDatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "./DatepickerWeb.overrides.css"
import { useTranslation } from "react-i18next"
import classes from "./DatepickerWeb.module.css"

import type { IconButtonStyleProps } from "@/theme"
import {
  AppIcons,
  AppText,
  Box,
  COLORS,
  FormControl,
  IconButton,
  Row,
  SIZES,
  useIsDarkMode,
} from "@/theme"
import type { ReactDatePickerCustomHeaderProps } from "react-datepicker"

import { StyleSheet } from "react-native"

/**
 *
 */
export function CustomHeader({
  date,
  decreaseMonth,
  increaseMonth,
  titleText,
}: ReactDatePickerCustomHeaderProps & { titleText?: string }) {
  const { t } = useTranslation()
  const iconButtonProps: IconButtonStyleProps = {
    size: "sm",
  }
  return (
    <Box alignItems={"flex-start"} display={"flex"}>
      {typeof titleText === "string" ? (
        <Box ml={"$3"}>
          <AppText colorScheme={"darkText"}>{titleText}</AppText>
        </Box>
      ) : null}
      <Row justifyContent={"space-between"} w={"$full"}>
        <IconButton
          {...iconButtonProps}
          IconComponent={AppIcons.ArrowLeft}
          onPress={decreaseMonth}
        />
        <AppText color={COLORS.$textDark.secondary} fontSize={"$sm"}>
          {t("datetimeWithVal", { month: "long", val: date, year: "numeric" })}
        </AppText>
        <IconButton
          {...iconButtonProps}
          IconComponent={AppIcons.ArrowRight}
          onPress={increaseMonth}
        />
      </Row>
    </Box>
  )
}

// TODO: Figure out datepickers

const styles = StyleSheet.create({
  pickerInput: {
    paddingVertical: SIZES.$1,
    width: 120,
  },
})

// TODO: Adapt this for dark mode with dark mode className
export function DatePickerWeb(props: ReactDatePickerProps) {
  const isDark = useIsDarkMode()
  return (
    <ReactDatePicker
      calendarClassName={isDark ? classes.calendarDark : classes.calendar}
      customInput={<FormControl.Input style={styles.pickerInput} />}
      {...props}
    />
  )
}
export type DatePickerProps = React.ComponentProps<typeof DatePickerWeb>
